const d = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' }

export function IcLeaf({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M5 19c0-8 6-14 14-14 0 8-6 14-14 14z"/><path d="M5 19c4-4 8-8 14-14"/></svg>
}
export function IcSparkle({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M12 3v6M12 15v6M3 12h6M15 12h6"/><path d="M6.5 6.5l2.5 2.5M15 15l2.5 2.5M6.5 17.5L9 15M15 9l2.5-2.5"/></svg>
}
export function IcFlower({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><circle cx="12" cy="12" r="2"/><path d="M12 10c0-3 1-5 3-5s3 2 1 5"/><path d="M14 12c3 0 5 1 5 3s-2 3-5 1"/><path d="M12 14c0 3-1 5-3 5s-3-2-1-5"/><path d="M10 12c-3 0-5-1-5-3s2-3 5-1"/></svg>
}
export function IcChart({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><circle cx="12" cy="12" r="8"/><path d="M12 4v8l6 3"/></svg>
}
export function IcHome({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M4 11l8-7 8 7v8a2 2 0 01-2 2h-3v-6h-6v6H6a2 2 0 01-2-2v-8z"/></svg>
}
export function IcBowl({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M3 11h18M4 11a8 8 0 0016 0"/><path d="M12 5v2M10 7h4"/></svg>
}
export function IcWellness({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><circle cx="12" cy="10" r="3"/><path d="M12 13c-4 1-6 4-6 7h12c0-3-2-6-6-7z"/><path d="M9 8c0-1.5 1.5-3 3-3s3 1.5 3 3"/></svg>
}
export function IcBag({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 016 0v2"/></svg>
}
export function IcCar({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M3 14v-2l2-5a2 2 0 012-1h10a2 2 0 012 1l2 5v2"/><path d="M3 14h18v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1H7v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-3z"/><circle cx="7.5" cy="15.5" r="1"/><circle cx="16.5" cy="15.5" r="1"/></svg>
}
export function IcBook({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M5 5h6a3 3 0 013 3v11a2 2 0 00-2-2H5V5z"/><path d="M19 5h-6a3 3 0 00-3 3v11a2 2 0 012-2h7V5z"/></svg>
}
export function IcMask({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M4 8c0-2 4-3 8-3s8 1 8 3v4c0 4-4 8-8 8s-8-4-8-8V8z"/><circle cx="9" cy="11" r="1"/><circle cx="15" cy="11" r="1"/><path d="M10 15c1 1 3 1 4 0"/></svg>
}
export function IcPlane({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M4 14l6-2 4-8 2 1-3 8 7 2-1 2-7-1-3 4-2-1 1-4-5-1 1-1z"/></svg>
}
export function IcHeart({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M12 19s-7-4-7-10a4 4 0 017-3 4 4 0 017 3c0 6-7 10-7 10z"/></svg>
}
export function IcSeed({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M5 20h14"/><path d="M12 20V9"/><path d="M12 13c-3 0-5-2-5-5 3 0 5 2 5 5z"/><path d="M12 11c2.5 0 4-1.5 4-4-2.5 0-4 1.5-4 4z"/><path d="M12 9c0-2 1-3 2-4"/></svg>
}
export function IcSparkAlt({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M12 3c0 4 1 6 5 7-4 1-5 3-5 7 0-4-1-6-5-7 4-1 5-3 5-7z"/></svg>
}
export function IcWind({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M4 9h10a2 2 0 100-4"/><path d="M4 15h14a2 2 0 110 4"/><path d="M4 12h7"/></svg>
}
export function IcCloud({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M7 18a4 4 0 010-8 5 5 0 019.5-1 3.5 3.5 0 01.5 6.95"/><path d="M7 18h10"/></svg>
}
export function IcBriefcase({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V5a2 2 0 012-2h2a2 2 0 012 2v2"/><path d="M3 12h18"/></svg>
}
export function IcTarget({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="1" fill="currentColor"/></svg>
}
export function IcMail({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3 8l9 6 9-6"/></svg>
}
export function IcLock({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/><circle cx="12" cy="15.5" r="1" fill="currentColor"/></svg>
}
export function IcArrowRight({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M5 12h14M13 6l6 6-6 6"/></svg>
}
export function IcUser({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><circle cx="12" cy="8" r="3.5"/><path d="M5 20c0-4 3-6 7-6s7 2 7 6"/></svg>
}
export function IcBell({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><path d="M6 16V11a6 6 0 0112 0v5l1.5 2H4.5L6 16z"/><path d="M10 20a2 2 0 004 0"/></svg>
}
export function IcWallet({ size = 24, ...p }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" {...d} {...p}><rect x="2" y="6" width="20" height="14" rx="3"/><path d="M2 10h20"/><circle cx="17" cy="15" r="1.5" fill="currentColor" stroke="none"/></svg>
}

export const CATEGORY_ICON = {
  'Hogar':        IcHome,
  'Comida':       IcBowl,
  'Bienestar':    IcWellness,
  'Cuidado':      IcWellness,
  'Compras':      IcBag,
  'Transporte':   IcCar,
  'Aprendizaje':  IcBook,
  'Experiencias': IcMask,
  'Viajes':       IcPlane,
  'Amor':         IcHeart,
  'Salario':      IcBriefcase,
  'Freelance':    IcUser,
  'Inversiones':  IcChart,
  'Regalo':       IcHeart,
  'Venta':        IcBag,
  'Bono':         IcSparkAlt,
  'Negocio':      IcSeed,
  'Ahorro':       IcTarget,
}

export function CategoryIcon({ category, size = 20, ...p }) {
  const Ic = CATEGORY_ICON[category] || IcSparkle
  return <Ic size={size} {...p} />
}
